// TODO - remove lint disable when editing this file
/* eslint-disable */
import { createReducer } from 'redux-ramda'
import { always, assoc, path, pipe, applySpec, prop, flip, merge } from 'ramda'
import { createAction } from 'redux-actions'
import { ACTION_INIT } from './commonActions'

// We can use this for other none-draft related story data
const ACTION_STORY_DATA = 'ellipsis.react.storyData'
export const setStoryData = createAction(ACTION_STORY_DATA)

const ACTION_STORY_NOTE = 'ellipsis.react.storyNote'
export const setStoryNote = createAction(ACTION_STORY_NOTE)

const ACTION_STORY_PUBLISH_VALIDATION =
  'ellipsis.react.story_publish_validation'
export const setPublishValidationData = createAction(
  ACTION_STORY_PUBLISH_VALIDATION
)

// storyObj: ng -> redux
export const ACTION_GET_NG_ANS = 'ellipsis.react.get_ng_ans'
export const requestStoryAns = createAction(ACTION_GET_NG_ANS)

export const getAnsLoadStatus = path(['storyData', 'ansLoadStatus'])

// storyObj: redux -> ng
export const ACTION_SET_NG_ANS = 'ellipsis.react.set_story_ans'
export const setStoryAns = ({ storyAns, isDirty }) => ({
  type: ACTION_SET_NG_ANS,
  payload: {
    storyAns,
    isDirty,
  },
})
export const getStoryAns = path(['storyData', 'story'])

export const getStoryData = path(['storyData'])

export const ACTION_SET_SCHEDULE_STATUS =
  'ellipsis.react.set_schedule_publish_status'
export const setScheduleStatus = createAction(ACTION_SET_SCHEDULE_STATUS)
export const getScheduleStatus = path(['storyData', 'scheduleStatus'])

export const ACTION_TYPE_SET_DOCUMENT = 'set_document'
export const setDocumentAction = createAction(ACTION_TYPE_SET_DOCUMENT)
export const getDocument = path(['storyData', 'document'])

export const ACTION_TYPE_SET_DRAFT_REVISION = 'set_draft_revision'
export const setDraftRevisionAction = createAction(
  ACTION_TYPE_SET_DRAFT_REVISION
)
export const getDraftRevision = path(['storyData', 'draftRevision'])

export const ACTION_TYPE_SET_CIRCULATION = 'set_circulation'
export const getCirculation = path(['storyData', 'circulations'])
export const setCirculation = createAction(ACTION_TYPE_SET_CIRCULATION)

export const ACTION_LEAVING_STORY = 'leaving_story'
export const leavingStoryAction = createAction(ACTION_LEAVING_STORY)

export const ACTION_SET_VARIANTS = 'ellipsis.react.set_variants'
export const setVariants = ({ variants }) => ({
  type: ACTION_SET_VARIANTS,
  payload: {
    variants,
  },
})

export const Statuses = {
  Disabled: 'disabled',
  Loading: 'loading',
  Ready: 'ready',
}

const initialState = {
  isPublished: false,
  scheduleStatus: {
    publish: undefined,
    unpublish: undefined,
  },
  storyNote: '',
  canonicalWebsite: undefined,
  ansLoadStatus: Statuses.Disabled,
  story: undefined,
  // placeholder for pubstack data
  document: undefined,
  circulations: [],
  draftRevision: undefined,
  variants: [],
}

export default createReducer(initialState, [
  [ACTION_INIT, () => always(initialState)],
  [ACTION_LEAVING_STORY, () => always(initialState)],
  [
    ACTION_STORY_DATA,
    pipe(
      applySpec({
        storyId: prop('storyId'),
        isPublished: prop('isPublished'),
        storyNote: prop('storyNote'),
        canonicalWebsite: prop('canonicalWebsite'),
      }),
      flip(merge)
    ),
  ],
  [
    ACTION_STORY_PUBLISH_VALIDATION,
    pipe(
      applySpec({
        isValid: prop('isValid'),
        validationMsg: prop('validationMsg'),
      }),
      flip(merge)
    ),
  ],
  [
    ACTION_GET_NG_ANS,
    // Simply setting the ANS status
    () => (state) => ({ ...state, ansLoadStatus: Statuses.Loading }),
  ],
  [
    ACTION_SET_NG_ANS,
    // storing storyObj from Angular -> Redux
    // Merge state with story object, as well as set the signal that loading is done
    (payload) => (state) => ({
      ...state,
      ansLoadStatus: Statuses.Ready,
      story: {
        ...payload.storyAns,
      },
    }),
  ],
  [ACTION_STORY_NOTE, assoc('storyNote')],
  [
    ACTION_TYPE_SET_DOCUMENT,
    (payload) => (state) => ({
      ...state,
      document: payload,
    }),
  ],
  [
    ACTION_TYPE_SET_DRAFT_REVISION,
    (payload) => (state) => ({
      ...state,
      draftRevision: payload,
    }),
  ],
  [
    ACTION_SET_SCHEDULE_STATUS,
    (payload) => (state) => ({
      ...state,
      scheduleStatus: payload,
    }),
  ],
  [
    ACTION_TYPE_SET_CIRCULATION,
    (payload) => (state) => ({
      ...state,
      circulations: payload,
    }),
  ],
  [
    ACTION_SET_VARIANTS,
    (payload) => (state) => ({
      ...state,
      variants: payload.variants,
    }),
  ],
])
